module.exports = __webpack_public_path__ + "loadingyungol.svg?923a4eec1bfbc46e82db1b1295793307";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loadingyungol.svg
// module id = 847
// module chunks = 0